import useSwr from "swr";
import api from "./api";
import { IMotivation } from "../types/IMotivation";

export function useFetchMotivation<Data = IMotivation[], Error = any>() {
  const url = `/motivation`;

  const { data, error } = useSwr<Data, Error>(url, async (url) => {
    const response = await api.get(url);
    return response.data;
  });

  return { data, error };
}
